import type { SVGProps } from 'react';
const SvgFlashOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#flash_off_svg__a)">
      <path
        fill="currentColor"
        d="M3.27 3 2 4.27l5 5V13h3v9l3.58-6.14L17.73 20 19 18.73 3.27 3ZM17 10h-4l4-8H7v2.18l8.46 8.46L17 10Z"
      />
    </g>
    <defs>
      <clipPath id="flash_off_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFlashOff;
